import history from '@ane/core/lib/CreateHistory';
import { combineEpics } from 'redux-observable';
import dataSourceDetailEpic from './DataSourceDetailEpic';
import dataSourceOverrideDetailEpic from './DataSourceOverrideDetailEpic';
import DataSourceAccessEpic from './DataSourceAccessEpic';
import { provideDataSourceSchemaEpics } from './DataSourceSchemaEpic';
import DataSourceHistoryEpic from './DataSourceHistoryEpic';
import DataSourceStatusEpic from './DataSourceStatusEpic';
import DataSourceDetailOverrideListEpic from './DataSourceDetailOverrideListEpic';
import DataSourceFlightFormatsEpic from '../../DataSourceCreate/epics/DataSourceFlightFormatsEpic';
import DataSourceProfilingEpic from './DataSourceProfilingEpic';
import DataSourceValidateTriggerEpic from './DataSourceValidateTriggerEpic';
const dataSourceSchemaEpic = provideDataSourceSchemaEpics(history);
export const rootEpic = combineEpics(dataSourceDetailEpic, dataSourceOverrideDetailEpic, DataSourceAccessEpic, dataSourceSchemaEpic, DataSourceHistoryEpic, DataSourceDetailOverrideListEpic, DataSourceStatusEpic, DataSourceFlightFormatsEpic, DataSourceProfilingEpic, DataSourceValidateTriggerEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
